import { ICopyWithBusinessRef } from '../../contracts/copy-with-business-ref.js';
import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { BusinessModuleRef } from '../../models/serializable/business-module-ref.js';
import { ProfileElement } from '../../models/serializable/profile-element.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ProfileElementCacheComponent extends Component implements ICopyWithBusinessRef {
  static readonly TYPE_ID: string = '1aea276409dc4034b1b32821a2b0342b';

  constructor(
    public readonly elements: ProfileElement[],
  ) {
    super();
  }

  get $typeId(): string {
    return ProfileElementCacheComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfileElementCacheComponent {
    return new ProfileElementCacheComponent(
        MapUtils.getList<ProfileElement>(
            map,
            'elements',
            (data) => context.fromData<ProfileElement>(data as SerializedData),
        ),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'elements': this.elements.map((element) => context.toData(element)),
    };
  }

  clone(): this {
    return new ProfileElementCacheComponent(
        this.elements.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: ProfileElementCacheComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameList(other.elements, this.elements);
  }

  copyWithBusinessRef(businessRef: BusinessModuleRef): this {
    return new ProfileElementCacheComponent(
        this.elements.map((e) => e.copyWithBusinessRef(businessRef)),
    ) as this;
  }
}

export class ProfileElementCacheComponentBuilder extends DataModelBuilder<ProfileElementCacheComponent> {
  build(context: SerializationContext, map: SerializedData): ProfileElementCacheComponent {
    return ProfileElementCacheComponent.fromMap(context, map);
  }
}
